import { Component, OnInit } from '@angular/core';
import {TableHeaderService} from '../../../resources/services/table-header.service';
import {FormService} from '../../../resources/services/form.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Location} from '@angular/common';
import {finalize} from 'rxjs/operators';
import {StoreKeyService} from '../../../resources/services/store-key.service';

@Component({
  selector: 'store-key-create',
  templateUrl: './store-key-create.component.html',
})
export class StoreKeyCreateComponent implements OnInit {


  constructor(private tableHeaderService: TableHeaderService,
              private _formService: FormService,
              private _route: ActivatedRoute,
              private _toastr: ToastrService,
              private _location: Location,
              private _router: Router,
              private _modelService: StoreKeyService) { }

  ngOnInit(): void {
  }

  onSubmit(form) {
    setTimeout(() => { form.disable() });;
    this._modelService.create(form.value).pipe(
      finalize(() => form.enable())
    ).subscribe(
      res => {
        this._router.navigate(['../', 'edit', res.id], { relativeTo: this._route });
      },
      err => {
        console.log(err);
      }
    );
  }

  back(e?: any) {
    if (e) e.preventDefault();

    this._location.back();
  }

}
